/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Flex, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaEye, FaPlus } from 'react-icons/fa'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { ModalDelete } from '../../../../components/ModalDelete'
import { WhiteContainer } from '../../../../components/WhiteContainer'
import { iFeedbackPersonalizadoQuery, iPutQuestaoCaixaSelecao, iPutQuestaoFlexivel, iQuestaoFlexivel } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'
import { Body } from '../../../Layouts/Body'
import { Questao } from './Components/Questao'
import { CaixaDeSelecao } from './Components/Questao/Components/CaixaDeSelecao'
import { Discursiva } from './Components/Questao/Components/Discursiva'
import { Escala } from './Components/Questao/Components/Escala'
import { ENPS } from './Components/Questao/Components/eNPS'
import { MultiplaEscolha } from './Components/Questao/Components/MultiplaEscolha'

type iParam = {
  pesquisaId: string
  trilhaId: string
  processoId: string
}

interface iForm {
  pesquisaId: string
  nome: string
  questoes: iQuestaoFlexivel[]
  isFeedback?: boolean
}

interface LocationProps {
  formularioEditavel: boolean
}

type InvalidMap = Record<
string,
{
  enunciado?: true
  escala?: true
  alternativas?: Record<string, true>

  // Talvez um dia usar esse atributo para validar se há alternativas
  semAlternativas?: true
}
>

export const FormularioPesquisaInterna: React.FC = () => {
  const toast = useToast()
  const param = useParams<iParam>()
  const nav = useNavigate()
  const { pathname } = useLocation()

  const [Formulario, setFormulario] = useState<iForm>()
  const [IsLoading, setIsLoading] = useState(false)
  const [ResetForm, setResetForm] = useState(false)
  const queryParams: iFeedbackPersonalizadoQuery = Object.fromEntries(new URLSearchParams(window.location.search).entries())
  const [InvalidMap, setInvalidMap] = useState<InvalidMap>({})

  const val = useLocation().state as LocationProps
  const formularioEditavel = val?.formularioEditavel ?? true

  function getFormulario(): void {
    if (!param.pesquisaId) {
      appApi.get('PesquisaInterna/PercepcoesEmpresa/Formulario')
        .then(res => setFormulario(res.data))
        .catch(err => console.log(err))
    } else {
      appApi.get(`PesquisaInterna/${param.pesquisaId}/Formulario?isTrilha=${((pathname.includes('Trilha') || (pathname.includes('Processo'))) && !formularioEditavel) ? 'true' : 'false'}`)
        .then(res => setFormulario(res.data))
        .catch(err => console.log(err))
    }
  }

  function AdicionarQuestao(): void {
    appApi.post(`PesquisaInternaQuestao/${param.pesquisaId ?? Formulario?.pesquisaId}`)
      .then(getFormulario)
      .catch(err => console.log(err))
  }

  function ResetarFormulario(): void {
    appApi.patch('PesquisaInterna/ResetarFormulario')
      .then(() => { window.location.reload() })
      .catch(err => console.log(err))
  }

  function OrdenarFormulario(): void {
    appApi.put(`PesquisaInterna/${param.pesquisaId ?? Formulario?.pesquisaId}/Ordenacao`, Formulario?.questoes.map(e => e.id))
      .then(() => toast({
        title: 'Ordenação salva com sucesso!',
        status: 'success',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      }))
      .catch(err => console.log(err))
  }

  function AtualizarFormulario(): void {
    appApi.put(`PesquisaInterna/${param.pesquisaId ?? Formulario?.pesquisaId}/AtualizarFormulario`)
      .then()
      .catch(err => console.log(err))
  }
  function onOrdenarFormulario(): void {
    appApi.put(`PesquisaInterna/${param.pesquisaId ?? Formulario?.pesquisaId}/Ordenacao`, Formulario?.questoes.map(e => e.id))
      .then()
      .catch(err => console.log(err))
  }

  function UpdatePropsEmComumQuestao(questao: iPutQuestaoFlexivel, id: string): void {
    appApi.put(`PesquisaInternaQuestao/${param.pesquisaId ?? Formulario?.pesquisaId}/questao/${id}`, questao)
      .then(() => {
        if (Formulario !== undefined) {
          const filtrado = { ...Formulario }
          const pos = filtrado.questoes.findIndex(e => e.id === id)
          if (pos !== -1) {
            filtrado.questoes[pos].enunciado = questao.enunciado
            filtrado.questoes[pos].tipo = questao.tipo
            filtrado.questoes[pos].obrigatoria = questao.obrigatoria
            setFormulario(filtrado)
          }
        }
      })
      .catch(err => console.log(err))
  }

  function UpdateCaixaDeSelecao(questaoId: string, form: iPutQuestaoCaixaSelecao): void {
    appApi.put(`PesquisaInternaQuestao/${param.pesquisaId ?? Formulario?.pesquisaId}/questao/${questaoId}/CaixaSelecao`, form)
      .then(() => {
        if (Formulario !== undefined) {
          const filtrado = { ...Formulario }
          const pos = filtrado.questoes.findIndex(e => e.id === questaoId)
          if (pos !== -1) {
            filtrado.questoes[pos].maxCaixaSelecao = form.maxCaixaSelecao
            filtrado.questoes[pos].minCaixaSelecao = form.minCaixaSelecao
            setFormulario(filtrado)
          }
        }
      })
      .catch(err => console.log(err))
  }

  function OnChangeEscala(escalaId: string, questaoId: string): void {
    appApi.put(`PesquisaInternaQuestao/${param.pesquisaId ?? Formulario?.pesquisaId}/questao/${questaoId}/Escala?escalaId=${escalaId}`)
      .then(() => {
        if (Formulario !== undefined) {
          const filtrado = { ...Formulario }
          const pos = filtrado.questoes.findIndex(e => e.id === questaoId)
          if (pos !== -1) {
            filtrado.questoes[pos].escalaId = escalaId === '' ? undefined : escalaId
            setFormulario(filtrado)
          }
        }
      })
      .catch(err => console.log(err))
  }

  function DeletarQuestao(id: string): void {
    appApi.delete(`PesquisaInternaQuestao/${param.pesquisaId ?? Formulario?.pesquisaId}/questao/${id}`)
      .then(() => {
        if (Formulario !== undefined) {
          const filtrado = { ...Formulario }
          filtrado.questoes = filtrado.questoes.filter(e => e.id !== id)
          setFormulario(undefined)
          setFormulario(filtrado)
        }
      })
      .catch(err => console.log(err))
  }

  function DesabilitarQuestao(id: string): void {
    appApi.delete(`PesquisaInternaQuestao/${param.pesquisaId ?? Formulario?.pesquisaId}/questao/${id}/Desabilitar`)
      .then(() => {
        getFormulario()
      })
      .catch(err => console.log(err))
  }

  function DuplicarQuestao(id: string): void {
    appApi.post(`PesquisaInternaQuestao/${param.pesquisaId ?? Formulario?.pesquisaId}/questao/${id}/Duplicar`)
      .then(() => {
        getFormulario()
        toast({
          title: 'Questão duplicada com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
      })
      .catch(err => console.log(err))
  }

  function AdicionarAlternativa(id: string): void {
    appApi.post(`PesquisaInternaQuestao/${param.pesquisaId ?? Formulario?.pesquisaId}/questao/${id}/Alternativa`)
      .then(getFormulario)
      .catch(err => console.log(err))
  }

  function RemoverAlternativa(questaoId: string, alternativaId: string): void {
    appApi.delete(`PesquisaInternaQuestao/${param.pesquisaId ?? Formulario?.pesquisaId}/questao/${questaoId}/Alternativa/${alternativaId}`)
      .then(getFormulario)
      .catch(err => console.log(err))
  }

  function UpdateTextoAlternativa(questaoId: string, alternativaId: string, texto: string): void {
    appApi.put(`PesquisaInternaQuestao/${param.pesquisaId ?? Formulario?.pesquisaId}/questao/${questaoId}/Alternativa/${alternativaId}`, { texto: texto })
      .then(() => {
        if (Formulario !== undefined) {
          const filtrado = { ...Formulario }
          const pos = filtrado.questoes.findIndex(e => e.id === questaoId)
          if (pos !== -1) {
            const posAlternativa = filtrado.questoes[pos].alternativas.findIndex(e => e.id === alternativaId)
            if (posAlternativa !== -1) {
              filtrado.questoes[pos].alternativas[posAlternativa].texto = texto
              setFormulario(filtrado)
            }
          }
        }
      })
      .catch(err => console.log(err))
  }

  function onAcima(i: number): void {
    setIsLoading(true)
    if (Formulario?.questoes) {
      const questaoCopiada: iQuestaoFlexivel = Formulario?.questoes[i]
      const questaoAnterior: iQuestaoFlexivel = Formulario?.questoes[i - 1]
      const arrayNovoQuestoes: iQuestaoFlexivel[] = []
      Formulario?.questoes.filter(e => e.id !== questaoCopiada.id).forEach((e) => {
        if (e.id === questaoAnterior.id) {
          arrayNovoQuestoes.push(Formulario.questoes[i])
          arrayNovoQuestoes.push(Formulario.questoes[i - 1])
        } else {
          arrayNovoQuestoes.push(e)
        }
      })
      setFormulario({ ...Formulario, questoes: arrayNovoQuestoes })
    }
    setIsLoading(false)
  }

  function onAbaixo(i: number): void {
    setIsLoading(true)
    if (Formulario?.questoes) {
      const questaoCopiada: iQuestaoFlexivel = Formulario?.questoes[i]
      const questaoSeguinte: iQuestaoFlexivel = Formulario?.questoes[i + 1]
      const arrayNovoQuestoes: iQuestaoFlexivel[] = []
      Formulario?.questoes.filter(e => e.id !== questaoCopiada.id).forEach((e) => {
        if (e.id === questaoSeguinte.id) {
          arrayNovoQuestoes.push(Formulario.questoes[i + 1])
          arrayNovoQuestoes.push(Formulario.questoes[i])
        } else {
          arrayNovoQuestoes.push(e)
        }
      })
      setFormulario({ ...Formulario, questoes: arrayNovoQuestoes })
    }
    setIsLoading(false)
  }

  function verificaSetas(i: number): string {
    if (Formulario?.questoes && Formulario.questoes.length === 1) {
      return '3'
    } else if (i === 0) {
      return '0'
    } else if (Formulario?.questoes && i === Formulario?.questoes.length - 1) {
      return '1'
    } else {
      return '2'
    }
  }

  function CheckQuestoes(): void {
    setInvalidMap({})

    if (formularioEditavel) {
      const { invalid, messages } = validarQuestoes(Formulario?.questoes ?? [])

      if (Object.keys(invalid).length > 0) {
        setInvalidMap(invalid)

        toast({
          title: 'Corrija os campos sinalizados antes de continuar.',
          description: messages.join(' '),
          status: 'error',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })

        // croll pro primeiro erro
        const firstId = Object.keys(invalid)[0]
        document.getElementById(`questao-${firstId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' })

        return
      }
    }

    OrdenarFormulario()
    if (param.pesquisaId) {
      nav(`${pathname.replace('Formulario', 'Aprovacao')}?fase=${queryParams.fase}`)
      AtualizarFormulario()
    } else {
      nav(-1)
    }
  }

  function validarQuestoes(questoes: iQuestaoFlexivel[]): { invalid: InvalidMap, messages: string[] } {
    const invalid: InvalidMap = {}
    const messages: string[] = []

    for (const q of questoes) {
      if (!q.enunciado || q.enunciado.trim().length === 0) {
        invalid[q.id] = { ...(invalid[q.id] ?? {}), enunciado: true }
      }

      if (q.tipo === 0 || q.tipo === 5) {
        if (!q.alternativas || q.alternativas.length === 0) {
          invalid[q.id] = { ...(invalid[q.id] ?? {}), semAlternativas: true }
        } else {
          for (const alt of q.alternativas) {
            if (!alt.texto || alt.texto.trim() === '') {
              invalid[q.id] = {
                ...(invalid[q.id] ?? {}),
                alternativas: { ...((invalid[q.id]?.alternativas) ?? {}), [alt.id]: true }
              }
            }
          }
        }
      }

      if (q.tipo === 6) {
        if (!q.escalaId || q.escalaId.trim() === '') {
          invalid[q.id] = { ...(invalid[q.id] ?? {}), escala: true }
        }
      }
    }

    if (Object.keys(invalid).length > 0) {
      if (Object.values(invalid).some(e => e.enunciado)) {
        messages.push('Existem questões sem enunciado.')
      }
      if (Object.values(invalid).some(e => e.semAlternativas)) {
        messages.push('Há questões de múltipla escolha/caixa de seleção sem alternativas.')
      }
      if (Object.values(invalid).some(e => e.alternativas && Object.keys(e.alternativas).length > 0)) {
        messages.push('Há alternativas sem texto.')
      }
      if (Object.values(invalid).some(e => e.escala)) {
        messages.push('Há questões do tipo escala sem escala selecionada.')
      }
    }

    return { invalid, messages }
  }

  useEffect(() => {
    getFormulario()
  }, [])

  useEffect(() => {
    onOrdenarFormulario()
  }, [Formulario])

  return (
    <Body>
      <ModalDelete
        isOpen={ResetForm}
        message={'Tem certeza que deseja restaurar o formulário para as configurações padrão? Outras mudanças realizadas serão perdidas'}
        onConfirm={ResetarFormulario}
        onRequestClose={() => setResetForm(false)}
        center
      />
      <WhiteContainer>
        <Flex margin={'0 0 1rem 0'}>
          <h1>{formularioEditavel ? 'Adicione as perguntas para o formulário' : 'Perguntas do formulário'}</h1>
        </Flex>

        {
          (Formulario) && (!IsLoading) && (

            <Flex pointerEvents={!formularioEditavel ? 'none' : 'inherit'} opacity={!formularioEditavel ? '0.5' : ''} flexDirection={'column'} gap={'1rem 0rem'}>
              {
                Formulario?.questoes.map((e, i) => {
                  return (
                    <Questao
                      key={e.id}
                      onDelete={DeletarQuestao}
                      onDesabilitar={DesabilitarQuestao}
                      onUpdate={UpdatePropsEmComumQuestao}
                      onDuplicar={DuplicarQuestao}
                      questao={e}
                      isModeloPadrao={!param.pesquisaId}
                      isInvalid={InvalidMap?.[e.id] !== undefined}
                      invalidEnunciado={!!InvalidMap[e.id]?.enunciado}
                      onAcima={() => onAcima(i)}
                      onAbaixo={() => onAbaixo(i)}
                      verificaSetas={() => verificaSetas(i)}
                      isFeedback={Formulario.isFeedback}
                      ciclicaIniciada={e.podeEditar === false}
                    >
                      {
                        e.tipo === 0
                          ? <MultiplaEscolha
                            onCreate={AdicionarAlternativa}
                            onDelete={RemoverAlternativa}
                            onUpdate={UpdateTextoAlternativa}
                            questao={e}
                            ciclicaIniciada={e.podeEditar === false}
                            invalidAlternativas={InvalidMap[e.id]?.alternativas}
                            invalidSemAlternativas={!!InvalidMap[e.id]?.semAlternativas}
                          />
                          : e.tipo === 1
                            ? <Discursiva
                              questao={e} />
                            : e.tipo === 5
                              ? <CaixaDeSelecao
                              onCreate={AdicionarAlternativa}
                              onDelete={RemoverAlternativa}
                              onUpdate={UpdateTextoAlternativa}
                              onUpdateMaxMin={UpdateCaixaDeSelecao}
                              questao={e}
                              ciclicaIniciada={e.podeEditar === false}
                              invalidAlternativas={InvalidMap?.[e.id]?.alternativas}
                              invalidSemAlternativas={!!InvalidMap?.[e.id]?.semAlternativas}
                            />
                              : e.tipo === 6
                                ? <Escala
                                onChangeEscala={(escalaId: string) => OnChangeEscala(escalaId, e.id)}
                                escalaId={e.escalaId ?? ''}
                                ciclicaIniciada={e.podeEditar === false}
                                isInvalid={!!InvalidMap[e.id]?.escala}
                              />
                                : <ENPS />
                      }
                    </Questao>
                  )
                })
              }
            </Flex>
          )
        }

        <Flex margin={'2rem 0'} gap='.75rem'>
          <ButtonCmp VarColor='Rosa' onClick={() => nav(`/Jornada/PesquisaInterna/Gestao/${param.pesquisaId ?? Formulario?.pesquisaId}/Previsualizar`)} leftIcon={<FaEye />}>Pré-visualizar formulário</ButtonCmp>
          {param.pesquisaId && <ButtonCmp isDisabled={!formularioEditavel} VarColor='Green2' onClick={AdicionarQuestao} leftIcon={<FaPlus />}>Adicionar pergunta</ButtonCmp>}
        </Flex>
        <Flex justifyContent={'end'} gap={'1rem'}>
            {!param.pesquisaId && <ButtonCmp onClick={() => {
              setResetForm(true)
            }}
              VarColor='Rosa'
            >Restaurar formulário para modelo padrão</ButtonCmp>}
            <ButtonCmp onClick={() => {
              CheckQuestoes()
            }}
              VarColor='Green2'
            >{!param.pesquisaId ? 'Salvar alterações' : 'Próximo'}</ButtonCmp>
        </Flex>
      </WhiteContainer>
    </Body>
  )
}
